import FeedPost from "./FeedPost";
export default FeedPost;